export const tspSolverConfig = {
  apiEndPoint: "https://resilience-tsp.herokuapp.com/shortest-route-given-geocodes",
  googlePopupBase: "https://www.google.com/maps/dir/",
};
